import styled from "styled-components";

export const $DescriptionText = styled.p`
  margin-top: 2.5rem;
  font-size: 1.75rem;
`
